<template>
  <div class="p-3 rounded-[20px] bg-[#FE5000]">
    <p class="mb-0 text-center text-[16px] font-lato text-[#fff]">
      ***If a replacement is recommended, call  
      <a class="no-underline text-[#fff]" :href="'tel:' + getNumber()">{{ getFormatedNumber() }} </a>  for pre-authorization ***
    </p>
  </div>
</template>


<script>
import { mapGetters } from "vuex";
export default {
    computed: {
    ...mapGetters([
      "quoteDetail",
    ]),
  },
  methods: {

    numberClicked(){
        
    },

    getNumber(){
        if (this.quoteDetail 
        && this.quoteDetail.partner_info
        && this.quoteDetail.partner_info.status == '1'
        && this.quoteDetail.partner_info.replacement_opportunity_number.length > 0) {


        return this.quoteDetail.partner_info.replacement_opportunity_number
      } else {
        return ""
      }
    },

    getFormatedNumber(){
        if (this.quoteDetail 
        && this.quoteDetail.partner_info
        && this.quoteDetail.partner_info.status == '1'
        && this.quoteDetail.partner_info.replacement_opportunity_number.length > 0) {
            let number = this.quoteDetail.partner_info.replacement_opportunity_number
            let str = number.substr(number.length - 10)
            return str.replace(/(\d\d\d)(\d\d\d)(\d\d\d\d)/, '($1) $2-$3');
      } else {
            return ""
      }
    }
  }
}
</script>
